const CODE = 'UnauthorizedUser';

export class UnauthorizedUserError extends Error {
  constructor() {
    super(CODE);
    this['error'] = { code: CODE };
  }
}
